import Image, { StaticImageData } from 'next/image';
import { LinkedInButton } from '../LinkedInButton';

interface TeamMemberProfileProps {
	picture: StaticImageData;
	name: string;
	linkedIn?: string;
	jobTitle: string;
	quote: string;
}

const TeamMemberProfile = (props: TeamMemberProfileProps) => {
	const { picture, name, linkedIn, jobTitle, quote } = props;

	return (
		<div className="grid gap-4">
			<div className="relative mx-auto">
				<Image
					src={picture}
					alt={`${name} smiling`}
					width={160}
					className="mx-auto rounded-full"
				/>
				{linkedIn && (
					<LinkedInButton
						href={linkedIn}
						className="absolute bottom-2 right-0"
					/>
				)}
			</div>
			<div>
				<p className="mb-2 text-lg font-bold">{name}</p>
				<span className="bg-slate-100 px-2 py-1 text-sm font-medium text-slate-500">
					{jobTitle}
				</span>
			</div>
			<p className="text-balance text-xs text-slate-500">{quote}</p>
		</div>
	);
};

export default TeamMemberProfile;
